<ng-container *ngIf="!state.dataLoading; else loader">
  <y42-orchestration-run-details-stripe
    *ngIf="state.runDetails"
    [details]="state.runDetails"
  ></y42-orchestration-run-details-stripe>

  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="job-tabs small-tabs">
    <mat-tab label="Jobs">
      <y42-orchestration-run-jobs-list
        class="flex w-full h-full"
        [jobs]="state.runJobs"
        [allowAssetRedirection]="true"
        (redirectToAsset)="redirectToAsset.emit($event)"
      ></y42-orchestration-run-jobs-list>
    </mat-tab>
    <mat-tab label="Job Dependencies">
      <y42-orchestration-diagram
        class="h-full"
        *ngIf="state.diagramConfig"
        [diagramConfig]="state.diagramConfig"
        (redirectToAsset)="redirectToAsset.emit($event)"
      ></y42-orchestration-diagram>
    </mat-tab>
  </mat-tab-group>
</ng-container>

<ng-template #loader>
  <mat-progress-bar mode="indeterminate" class="w-full"></mat-progress-bar>
</ng-template>
